import { makeStyles, tokens } from '@fluentui/react-components';

export const useReportsPageStyles = makeStyles({
    content: {
        padding: tokens.spacingVerticalS,
    },
    toolbar: {
        padding: tokens.spacingVerticalXS,
        borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
        backgroundColor: tokens.colorNeutralBackground1,
        minHeight: 'auto',
    },
    customDateContainer: {
        marginTop: tokens.spacingVerticalM,
        opacity: '0.6',
    },
    customDateContainerActive: {
        marginTop: tokens.spacingVerticalM,
        opacity: '1',
    },
    monthContainer: {
        marginTop: tokens.spacingVerticalS,
        opacity: '0.6',
    },
    monthContainerActive: {
        marginTop: tokens.spacingVerticalS,
        opacity: '1',
    },
    buttonWrapper: {
        marginTop: tokens.spacingVerticalL,
        display: 'flex',
        justifyContent: 'center',
    },
    errorText: {
        color: tokens.colorPaletteRedForeground1,
    },
});
